import {Badge_SizeFinderFit_SizeFinderBadgeStyle} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/badge.types';
import {
  SizeSelection,
  SizeSelection_Size,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';

const getRecommendedSize = ({
  sizeSelection,
}: {
  sizeSelection: SizeSelection | undefined;
}) => {
  if (!sizeSelection) return undefined;

  switch (sizeSelection.type?.$case) {
    case 'sizes': {
      const sizes = sizeSelection.type.sizes.sizes;
      return findRecommendedSize(sizes);
    }

    case 'sizeRuns': {
      const sizeRuns = sizeSelection.type.sizeRuns.sizeRuns;
      if (sizeRuns[0]?.sizes) {
        return findRecommendedSize(sizeRuns[0].sizes);
      }
      return undefined;
    }

    case 'groupedSizes': {
      const sizeGroups = sizeSelection.type.groupedSizes.groups;
      if (sizeGroups[0]?.content?.$case === 'sizes') {
        const sizes = sizeGroups[0].content.sizes.sizes;
        return findRecommendedSize(sizes);
      }

      if (sizeGroups[0]?.content?.$case === 'sizeRuns') {
        const sizes = sizeGroups[0].content.sizeRuns.sizeRuns[0]?.sizes;
        if (sizes) {
          return findRecommendedSize(sizes);
        }
      }

      return undefined;
    }

    case 'inlineSelection': {
      const sizes = sizeSelection.type.inlineSelection.sizes;
      return findRecommendedSize(sizes);
    }

    case 'oneSize': {
      return sizeSelection.type.oneSize.size;
    }

    default:
      return undefined;
  }
};

const findRecommendedSize = (
  sizes: SizeSelection_Size[],
): SizeSelection_Size | undefined => {
  // A clear recommendation needs a >= 80% fit or prominentely styled badge
  // Since BE decides the style based on the percentage we use the style in order to
  // determine whether it is a clear recommendation and don't have to deal with the percentage-string.
  return sizes.find(size =>
    size.leftBadges.find(
      badge =>
        badge.type?.$case === 'sizeFinderFit' &&
        badge.type.sizeFinderFit.style ===
          Badge_SizeFinderFit_SizeFinderBadgeStyle.PROMINENT,
    ),
  );
};

export const useSizeAdvisorRecommendation = (sizeSelection: SizeSelection) => {
  const recommendedSize = getRecommendedSize({
    sizeSelection,
  });

  return recommendedSize;
};
